import config from "@/utils/Config";
import {get, post } from "@/utils/request";

export function getAlbumTypeList(params = {}) {
    return get(config.BASE_URL, config.getAlbumTypeList, params)
}

export function getCuratedAlbumLit(params = {}) {
    return get(config.BASE_URL, config.getCuratedAlbumLitUrl, params)
}

export function getMuseumDataList(params = { userId: userId, typeId: typeId }) {
    return post(config.BASE_URL, config.getMuseumDataList, params)
}

export function saveImageSort(params) {
    return post(config.BASE_URL, config.saveImageSortUrl, params)
}

export function saveMuseumType(params = {}) {
    return post(config.BASE_URL, config.saveMuseumTypeUrl, params)
}

export function saveMuseumDetail(params = {}, configParams) {
    return post(config.BASE_URL, config.saveMuseumDetailUrl, params, configParams)
}

export function getAdminAlbumTypeList(params = {}) {
    return post(config.BASE_URL, config.getAlbumTypeListUrl, params)
}

export function delAlbumTypeInfo(params = { id: id }) {
    return post(config.BASE_URL, config.delAlbumTypeUrl, params)
}

export function getAlbumList(params = {}) {
    return post(config.BASE_URL, config.getAlbumListUrl, params)
}

export function del(params = { id: id }) {
    return post(config.BASE_URL, config.delAlbumUrl, params)
}

